import {  doc, setDoc } from "firebase/firestore";
import React, { useState } from "react";
import useAuth from "../Auth/useAuth";
import { db } from "../firebase";

const DashboardHome = () => {
  const {user}=useAuth()
  const [fullName,setFullName] = useState("");
  const [fathersName,setFathersName]= useState("");
  const [dateOfBirth,setDateOfBirth]= useState("");
  const [category,setCategory]= useState("");
  const [studentCode,setStudentCode] = useState("");
  const [mothersName,setMothersName]= useState("");
  const [gender,setGender] = useState("");
  const [contactNumber,setContactNumber] = useState("");
  const [permanentAddressLine,setPermanentAddressLine] = useState("");
  const [permanentAreaLocality,setPermanentAreaLocality]= useState("");
  const [permanentApartmentHouse,setPermanentApartmentHouse] = useState("");
  const [permanentZip,setPermanentZip]= useState("");
  const [permanentCity,setPermanentCity]= useState("");
  const [permanentState,setPermanentState]= useState("");
  const [permanentCountry,setPermanentCountry]=useState("");
  const [correspondenceAddressLine,setCorrespondenceAddressLine] = useState("");
  const [correspondenceAreaLocality,setCorrespondenceAreaLocality]= useState("");
  const [correspondenceApartment,setCorrespondenceApartment] = useState("");
  const [correspondenceZip,setCorrespondenceZip]= useState("");
  const [correspondenceCity,setCorrespondenceCity]= useState("");
  const [correspondenceState,setCorrespondenceState]= useState("");
  const [correspondenceCountry,setCorrespondenceCountry]=useState("");

  
  // const fillFormStudent = async () => {
  //   await setDoc(doc(db, "studentLists",user.uid), {
  //    fullName,
  //    fathersName,
  //    mothersName,
  //    dateOfBirth,
  //    contactNumber,
  //     gender,
  //     category,
  //     studentCode,
  //     permanentAddressLine,
  //     permanentApartmentHouse,
  //     permanentAreaLocality,
  //     permanentCity,
  //     permanentState,
  //     permanentCountry,
  //     permanentZip,
  //     correspondenceAddressLine,
  //     correspondenceApartment,
  //     correspondenceAreaLocality,
  //     correspondenceCity,
  //     correspondenceCountry,
  //     correspondenceState,
  //     correspondenceZip,
  //   }).then(()=>{
  //     window.location.reload(false)
  //   })
  // };

  return (
    <div className="bg-blue-100 ">
      <h1 className="text-left ml-6 pt-3 text-2xl font-semibold">
        Student Profile
      </h1>
      <div className="container">
        <div className=" bg-white text-black-500 text-lg font-bold  grid grid-cols-3 ">
          <div
            className=" bg-white text-black-500 text-lg font-bold p-2 hover:border-2 "
          >
            Profile
          </div>
          <div
            className=" bg-white text-black-500 text-lg font-bold p-2 hover:border-2"
          >
            Contact
          </div>
        </div>
          <div className="p-4 ">
            <div className="bg-white grid grid-cols-2  ml-5 mr-5">
              <div className=" bg-white text-black-500 text-lg font-bold "></div>
            </div>
           
            <div className="grid grid-cols-2  pl-5 pr-5 ">
              <div className="  text-black-500 text-lg font-bold text-center pt-10  ">
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Full Name
                      </label>
                    </div>
                    <div className="md:w-2/5">
                      <input
                      value={fullName}
                      onChange={(e) => {
                        setFullName(e.target.value);
                                 }}
                        type="text"
                        placeholder="full Name"
                        className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6 ">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Father's Name
                      </label>
                    </div>
                    <div className="md:w-2/5">
                      <input
                       value={fathersName}
                       onChange={(e) => {
                         setFathersName(e.target.value);
                                  }}
                        type="text"
                        placeholder="Father's Name"
                        className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        D.O.B
                      </label>
                    </div>
                    <div className="md:w-2/5">
                      <input
                         value={dateOfBirth}
                         onChange={(e) => {
                           setDateOfBirth(e.target.value);
                                    }}
                        type="date"
                        placeholder="Date Of Birth"
                        className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>
                  </div>
                </div>

                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Category
                      </label>
                    </div>
                    <div className="md:w-2/5">
                      <select
                      value={category}
                      onChange={(e) => {
                        setCategory(e.target.value);
                                 }}
                        className="form-select 
      block
      w-64
      px-3
      py-1.5
      text-base
      font-normal
      text-gray-700
      bg-white bg-clip-padding bg-no-repeat
      border border-solid border-gray-300
      rounded
      transition
      ease-in-out
      m-0
      focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        aria-label="Default select example"
                      >
                        <option value="null"> select</option>
                      <option value="Schedule Caste">Schedule Caste</option>
                      <option value="Schedule Tribe">Schedule Tribe</option>
                      <option value="General">General</option>
                      <option value="OBC I">OBC I</option>
                      <option value="OBC II">OBC II</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" text-black-500 text-lg font-bold text-center pt-10  pl-10 ">
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Student Code
                      </label>
                    </div>
                    <div className="md:w-2/5">
                      <input
                        value={studentCode}
                        onChange={(e) => {
                          setStudentCode(e.target.value);
                                   }}
                        type="text"
                        placeholder="Student Code"
                        className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Mother's Name
                      </label>
                    </div>
                    <div className="md:w-2/5">
                      <input
                       value={mothersName}
                       onChange={(e) => {
                         setMothersName(e.target.value);
                                  }}
                        type="text"
                        placeholder="Mother's Name"
                        className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Gender
                      </label>
                    </div>
                    <div className="md:w-2/5">
                      <select
                        value={gender}
                        onChange={(e) => {
                          setGender(e.target.value);
                                   }}
                        className="form-select 
      block
      w-64
      px-3
      py-1.5
      text-base
      font-normal
      text-gray-700
      bg-white bg-clip-padding bg-no-repeat
      border border-solid border-gray-300
      rounded
      transition
      ease-in-out
      m-0
      focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        aria-label="Default select example"
                      >
                        <option value="null"> select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Contact No.
                      </label>
                    </div>
                    <div className="md:w-2/5">
                      <input
                       value={contactNumber}
                       onChange={(e) => {
                         setContactNumber(e.target.value);
                                  }}
                        type="text"
                        placeholder="Contact No"
                        className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full p-5">
            <div className="mb-2 text-left ">
              <span className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
                Permanent Address
              </span>
            </div>
            <div className="w-full">
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Address Line 1:
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    value={permanentAddressLine}
                    onChange={(e) => {
                      setPermanentAddressLine(e.target.value);
                               }}
                    type="text"
                    placeholder=" Address Line 1"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Area/Road/Locality:
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    value={permanentAreaLocality}
                    onChange={(e) => {
                      setPermanentAreaLocality(e.target.value);
                               }}
                    type="text"
                    placeholder=" Area/Road/Locality"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Apartment
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    value={permanentApartmentHouse}
                    onChange={(e) => {
                      setPermanentApartmentHouse(e.target.value);
                               }}
                    type="text"
                    placeholder="  Apartment"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Zip Code
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                       value={permanentZip}
                       onChange={(e) => {
                         setPermanentZip(e.target.value);
                                  }}
                      type="text"
                      placeholder="  Zip Code"
                      className=" w-32  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      City
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                     value={permanentCity}
                     onChange={(e) => {
                       setPermanentCity(e.target.value);
                                }}
                      type="text"
                      placeholder=" City"
                      className=" w-32  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                <div className="mb-4 md:w-1/3">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      State
                    </label>
                  </div>
                  <div className="md:w-2/3">
                    <input
                     value={permanentState}
                     onChange={(e) => {
                       setPermanentState(e.target.value);
                                }}
                      type="text"
                      placeholder=" State"
                      className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Country
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    value={permanentCountry}
                    onChange={(e) => {
                      setPermanentCountry(e.target.value);
                               }}
                    type="text"
                    placeholder="  Country"
                    className=" w-full px-3  py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full p-5">
            <div className="mb-2 text-left ">
              <span className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
                Correspondence Address
              </span>
            </div>
            <div className="w-full">
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Address Line 1:
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                  value={correspondenceAddressLine}
                  onChange={(e) => {
                    setCorrespondenceAddressLine(e.target.value);
                             }}
                    type="text"
                    placeholder=" Address Line 1"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Area/Locality:
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                   value={correspondenceAreaLocality}
                   onChange={(e) => {
                     setCorrespondenceAreaLocality(e.target.value);
                              }}
                    type="text"
                    placeholder=" Area/Locality"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Apartment
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    value={correspondenceApartment}
                    onChange={(e) => {
                      setCorrespondenceApartment(e.target.value);
                               }}
                    type="text"
                    placeholder="  Apartment"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Zip Code
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                     value={correspondenceZip}
                     onChange={(e) => {
                       setCorrespondenceZip(e.target.value);
                                }}
                      type="text"
                      placeholder="  Zip Code"
                      className=" w-32  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      City
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                    value={correspondenceCity}
                    onChange={(e) => {
                      setCorrespondenceCity(e.target.value);
                               }}
                      type="text"
                      placeholder=" City"
                      className=" w-32  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      State
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                         value={correspondenceState}
                         onChange={(e) => {
                           setCorrespondenceState(e.target.value);
                                    }}
                      type="text"
                      placeholder=" State"
                      className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Country
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                   value={correspondenceCountry}
                   onChange={(e) => {
                     setCorrespondenceCountry(e.target.value);
                              }}
                    type="text"
                    placeholder="  Country"
                    className=" w-full px-3  py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>
            </div>
            <div className="text-center ease-in-out duration-300 pb-6 ">
              <button 
              // onClick={fillFormStudent}
              className="w-24 text-white text-xl h-10 text-center font-semibold rounded-md  bg-[#1273DE] hover:bg-[#117BEF] active:bg-[#117BEF] focus:outline-none focus:ring focus:ring-[#117BEF]">
                Save
              </button>
            </div>
          </div>
   
     
      
      </div>
    </div>
  );
};

export default DashboardHome;
